import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';

import { SharedService } from '../../../../shared/shared.service';

@Component({
  selector: 'app-carica-voti-placement',
  templateUrl: './carica-voti-placement.component.html',
  styleUrls: ['./carica-voti-placement.component.css'],
})
export class CaricaVotiPlacementComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  // COMBO BOX
  submitted = false;

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  verifyFile(file: File, event: any) {
    if (file && file.name.indexOf('.csv') <= 0) {
      this.sharedService.openKoModal();
    } else {
      this.sharedService.openOkModal();
      this.modalSubscribe = this.ngxSmartModalService
        .getModal('okModal')
        .onClose.subscribe((modal: NgxSmartModalComponent) => {
          window.location.reload();
        });
    }
  }
}
